<style scoped>
.manage-group-container {
  background: #fff;
  padding: 15px;
}

.field-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.field-container > .label {
  margin-right: 20px;
  min-width: 120px;
}

.field-container > .field {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
}

.field-container.remove {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.update-resource {
  display: block;
  margin-left: auto;
}

textarea.ivu-input {
  max-height: 200px;
}

button.ivu-btn.ivu-btn-error {
  height: 35px;
}

.upload-avatar{
  width: 100%;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.upload-avatar > button{
  width: 100%;
}
</style>

<style>
.manage-group-container > .field-container > .field > .ivu-input-wrapper > textarea.ivu-input{
  max-height: 200px;
}
</style>

<template>
  <div class="manage-group-component">
    <div class="manage-group-container">
      <!-- <div class="upload-avatar">
        <Button icon="camera" v-on:click="uploadImage" :loading="imageUploadLoader">Change Group Avatar</Button>
      </div> -->
      <div class="field-container">
        <div class="label">
          <p class="label-info">Group Name</p>
        </div>
        <div class="field">
          <Input v-model="resourceInfo.title" :placeholder="'Group Name'" ></Input>
        </div>
      </div>
      <div v-show="resourceInfo.type=='alliance'">
        <div class="field-container">
          <div class="label">
            <p class="label-info">Estimated Members</p>
          </div>
          <div class="field">
            <RadioGroup v-model="resourceInfo.estimate_members">
              <Radio label="less than 100" style="display:block">
              </Radio>
              <Radio label="100-1000" style="display:block">
              </Radio>
              <Radio label="1001-5000" style="display:block">
              </Radio>
              <Radio label="5000+" style="display:block">
              </Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="field-container">
          <div class="label">
            <p class="label-info">Facebook Page</p>
          </div>
          <div class="field">
            <Input v-model="resourceInfo.fb_url" type="email" :placeholder="'Facebook page email'" ></Input>
          </div>
        </div>
      </div>
      <div class="field-container" v-if="false">
        <div class="label">
          <p class="label-info">Group Info</p>
        </div>
        <div class="field">
          <Input v-model="resourceInfo.description" :placeholder="'Group Info'"
            type="textarea" :autosize="true"></Input>
        </div>
      </div>
      <div class="field-container">
        <div class="label">
          <p class="label-info">Allow members to post
            <Tooltip content="Allowing members to post to group timeline" placement="top-start">
              <Icon type="information-circled"></Icon>
          </Tooltip>
          </p>
        </div>
        <div class="field">
          <i-switch :value="convertToBoolean(resourceInfo.members_can_post)" @on-change="triggerSwitch($event, 'members_can_post')">
            <Icon type="android-done" slot="open"></Icon>
            <Icon type="android-close" slot="close"></Icon>
          </i-switch>
        </div>
      </div>
      <div class="field-container" v-show="resourceInfo.members_can_post">
        <div class="label">
          <p class="label-info">Require Approval
            <Tooltip content="Allowing members to post to group timeline" placement="top-start">
              <Icon type="information-circled"></Icon>
          </Tooltip>
          </p>
        </div>
        <div class="field">
          <i-switch :value="convertToBoolean(resourceInfo.post_require_approval)" @on-change="triggerSwitch($event, 'post_require_approval')">
            <Icon type="android-done" slot="open"></Icon>
            <Icon type="android-close" slot="close"></Icon>
          </i-switch>
        </div>
      </div>
      <div class="field-container">
        <div class="label">
          <p class="label-info">Group Type
            <Tooltip content="Group privacy" placement="top-start">
              <Icon type="information-circled"></Icon>
          </Tooltip>
          </p>
        </div>
        <div class="field">
          <RadioGroup v-model="resourceInfo.access">
            <Radio label="public">
              <span>Public</span>
            </Radio>
            <Radio label="hidden">
              <span>Private</span>
            </Radio>
          </RadioGroup>
        </div>
      </div>
      <Button type="primary" class="update-resource" v-on:click="onUpdate"
        :loading="loadUpdate">Update</Button>

      <div v-if="false" class="field-container remove">
        <div class="label">
          <p class="label-info">Remove Group</p>
          <small>This group will permanently deactivated and people who followed this group won't see this anymore.</small>
        </div>
        <div class="field">
          <Button type="error" v-on:click="showRemoveConfirmation = true">Remove</Button>
        </div>
      </div>
    </div>

    <UploadImageComponent ref="uploadImage" @emitBase64="onLoadImage"></UploadImageComponent>
    <ModalHolder :title="'Confirm'" m-top="0" :is-show="showRemoveConfirmation">
      <template slot="mcontent">
        <p>Are you sure you want to remove this group?</p>
      </template>
      <template slot="mfooter">
          <Button type="text" @click="showRemoveConfirmation = false">Cancel</Button>
          <Button type="default" v-on:click="removeGroup" :loading="removeGroupLoader">Confirm</Button>
      </template>
    </ModalHolder>
  </div>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import UploadImageComponent from '@/components/UploadImageComponent';
import _ from "lodash";

export default {
  name: "ManageGroupComponent",
  components: {
    ModalHolder,
    UploadImageComponent
  },
  data() {
    return {
      resourceInfoHolder: {},
      showRemoveConfirmation: false,
      form: {
        thumbnail_photo: null,
        title: null,
        members_can_post: null,
        access: null,
        description: null,
      },
      triggeredSwitch: {}
    };
  },
  mounted(){
    setTimeout(() => {
      this.resourceInfoHolder = _.cloneDeep(this.$store.state.resource.singleResource.data);
    }, 1000);
  },
  computed: {
    resourceInfo: {
      get() {
        return this.resourceInfoHolder;
      },
      set(val) {
        this.resourceInfoHolder = val;
      }
    },
    loadUpdate: {
      get() {
        return this.$store.state.resource.singleResource.isLoading;
      }
    },
    removeGroupLoader: {
      get() {
        return this.$store.state.resource.singleResource.groupRemoveLoader;
      }
    },
    imageUploadLoader: {
      get() {
        return this.$store.state.publicModule.imageUploadLoader;
      }
    },
    postImageFile: {
      get(){
        return this.$store.state.publicModule.uploadedImage;
      }
    },
  },
  methods: {
    convertToBoolean(num) {
      if (Number.isInteger(num)) {
        return Boolean(num);
      }
    },
    convertToInt(num) {
      return num ? 1 : 0;
    },
    onUpdate(){
      for (let key in this.triggeredSwitch) {
          if (this.triggeredSwitch.hasOwnProperty(key)) {
              this.resourceInfo[key] = this.convertToInt(this.triggeredSwitch[key])
          }
      }
      this.$store.dispatch('resource/updateGroupInfo', {id: this.resourceInfo.id, data: this.resourceInfo}).then(res => {
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Updated' },
          icon: 'checkmark',
          message: { content: 'Group Info Updated.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });
      });
    },
    removeGroup(){
      this.$store.dispatch('resource/removeGroup', this.resourceInfoHolder.id).then(res => {
        this.showRemoveConfirmation = false;
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Removed' },
          icon: 'checkmark',
          message: { content: 'Group successfully removed.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });
        this.$router.push({ path: "/profile?tab=stuff" });
      });
    },
    uploadImage(){
      this.$refs.uploadImage.triggerUpload()
    },
    triggerSwitch(data, type){
      this.resourceInfo[type] = data;
      this.triggeredSwitch[type] = data;
    },
    onLoadImage(image){
      this.$store.dispatch('publicModule/uploadBase64Image', {base64_image: image}).then(res => {
        if(!_.isEmpty(this.postImageFile)){
          this.resourceInfo.thumbnail_photo = this.postImageFile.uploaded[0]
          this.onUpdate()
        }
      })
    }
  }
};
</script>
